import { memo } from "react"
import moment from "moment"
import makeStyles from "@material-ui/core/styles/makeStyles"

import TableCell from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Checkbox from "@material-ui/core/Checkbox"
import Box from "@material-ui/core/Box"

import IconButton from "@material-ui/core/IconButton"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import CheckCircleIcon from "@material-ui/icons/CheckCircle"
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked"

import { useAppSelector } from "common/hooks"
import { Role } from "common/types"

import { ActionCreators, useAdminDispatch } from "../Context"

const useStyles = makeStyles(theme => ({
    disabled: {
        opacity: theme.palette.action.disabledOpacity
    }
}))

const Row = props => {
    const { data, showCompany } = props
    const dispatch = useAdminDispatch()

    const { user: currentUser } = useAppSelector(state => state.auth)
    const currentUserRole = Role[currentUser.role]
    const disabled = currentUserRole < Role.Superadmin

    const classes = useStyles()

    function onClickEdit() {
        dispatch(ActionCreators.setToEdit(data))
    }

    function onClickDelete() {
        dispatch(ActionCreators.setToDelete([data]))
    }

    function onCheckboxChange() {
        dispatch(ActionCreators.toggleSelect(data))
    }

    const { name, company, isSelected, enabled, setting, title } = data
    const EnabledIcon = enabled ? CheckCircleIcon : RadioButtonUncheckedIcon

    return (
        <TableRow
            selected={isSelected}
            {...(!enabled && { className: classes.disabled })}
            onDoubleClick={onClickEdit}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onChange={onCheckboxChange}
                    disabled={disabled}
                />
            </TableCell>

            <TableCell>{name}</TableCell>

            <TableCell>{title}</TableCell>

            <TableCell>
                {setting?.lastPublishAt &&
                    moment(setting.lastPublishAt, moment.ISO_8601).format(
                        "MMMM DD, YYYY"
                    )}
            </TableCell>

            {showCompany && (
                <TableCell>
                    <span>{company?.name || "Unassigned"}</span>
                </TableCell>
            )}

            <TableCell align="center">
                <EnabledIcon fontSize="small" color="primary" />
            </TableCell>

            <TableCell align="right">
                <Box display="flex" justifyContent="flex-end">
                    <IconButton onClick={onClickEdit} disabled={disabled}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={onClickDelete} disabled={disabled}>
                        <DeleteIcon />
                    </IconButton>
                </Box>
            </TableCell>
        </TableRow>
    )
}

export default memo(Row)
